import React from "react";
import Icon from "../../Images/Icon-spin.png";

const Spinner = () => {
  return <img src={Icon} alt="icon spinner" className="animate-spin w-5 h-5" />;
};

export default Spinner;
